import React from 'react'

export const SearchResultLoading: React.FC = () => {
  return (
    <div className="jr-list-item">
      <div className="jr-list-group shrink">
        <div className="profile-dot profile-dot--lg me-3 skeleton"></div>
      </div>
      <div className="jr-list-group grow">
        <p className="h5 mb-0 skeleton"></p>
        <p className="text-small text-meta mb-0 skeleton"></p>
      </div>
    </div>
  )
}
